import { metricConfig } from '../data/metrics/metricConfigBuilder';

export const tranformPhoenixData = (data, key, text, isAccountData) => {
	return data.map(item => ({
		...item,
		key: item[key],
		text: isAccountData ? `${item.accountID} - ${item[text]}` : item[text],
	})).sort((a, b) => a.text.localeCompare(b.text));
};


